import { useQuery } from "@tanstack/react-query";
import { clientContactApi } from "./axios";
import {
    ValidateCurrentToken,
    LogoutSystem, 
} from '../../helpers';
import { OneClientInvoice, ServiceResponseI } from "../../interfaces";
import { AxiosError } from "axios";

export const getAllClientContactbyClientId = async (id:number) => {
    try{ 
        const validateToken = ValidateCurrentToken();
        if(!validateToken) throw new Error('TOKEN INVALIDO');


        const { data } = await clientContactApi.get<ServiceResponseI<OneClientInvoice[]>>(`/all-by-client-id/${id}`,{ headers: { 'Authorization': validateToken}});
        
        return data;

    }catch(err){
        const obj = (err as AxiosError).response;
        if(obj?.status === 401) {
            
            LogoutSystem();
        }
        throw new Error((err as Error).message)
    }
    
}

export const clientContactById = async (id: number): Promise<ServiceResponseI<OneClientInvoice | any>> => {
    try {
        const validateToken = ValidateCurrentToken();
        if (!validateToken) throw new Error('TOKEN INVALIDO');
        const { data } = await clientContactApi.get<ServiceResponseI<OneClientInvoice | any>>(`/${id}`, { headers: { 'Authorization': validateToken } });
        return data;
    } catch (err) {
        const obj = (err as AxiosError).response;
        if (obj?.status === 401) {
            
            LogoutSystem();
        }
        throw new Error((obj?.data as Error).message)
    }
}

